import { render, staticRenderFns } from "./layers.vue?vue&type=template&id=3165a1ca&scoped=true"
import script from "./layers.vue?vue&type=script&lang=js"
export * from "./layers.vue?vue&type=script&lang=js"
import style0 from "./layers.vue?vue&type=style&index=0&id=3165a1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165a1ca",
  null
  
)

export default component.exports